<template>
	<div class="layer-project" data-project-name="hanssem-o4o">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit"><em>Hanssem.com</em> O4O Platform</h1>
					<a href="http://www.hanssem.com" class="link" target="_blank"
						>www.hanssem.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						온/ 오프라인을 넘나들며 빠르게 변화하는 시장 트렌드에 대응하기 위해
						온라인과 오프라인을 잇는 O4O(Online for Offline) 플랫폼으로서의
						기능을 강화하여 홈페이지 제작했습니다.<br />
						이미지, 동영상, VR 등 다양한 형식으로 공간 패키지 콘텐츠를 제공하고,
						관심 상품 또는 공간 패키지 선택 시 최적의 오프라인 매장을 안내 하는
						등 <br />
						고객과 전국의 오프라인 매장을 연결하여 편리한 인테리어 쇼핑을 돕고
						대리점 방문을 통해 비즈니스 활성화에 기여할 수 있는 플랫폼을
						구축했습니다.
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li>
								<span>O4O<br />(Online for Offline)<br />Platform</span>
							</li>
							<li>
								<span>Space<br />Package<br />Contents</span>
							</li>
							<li>
								<span>Convenient<br />Interior<br />Shopping</span>
							</li>
						</ul>
						<ul class="diagram02">
							<li>
								<span>Hanssem.com<br />O4O Platform</span>
							</li>
						</ul>
					</div>
				</div>
			</section>
			<section class="section section01 full">
				<div class="inner-section">
					<div class="content content01">
						<div class="cont-tit-area max-limit">
							<strong class="project-subtit">PC Web</strong>
							<p class="cont-desc">
								온라인에서 한샘의 제품에 관심을 유도하고
								<br class="lb-t" />예시를 어필하여 <br class="lb-m" />오프라인의
								구매까지 <br class="lb-t" />연계되는 구조로
								<br class="lb-w" />제품에 집중할 수 있도록
								<br class="lb-t" />디자인 하였습니다.
							</p>
						</div>
						<div class="detail-img max-limit">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/hanssem/sec1-main-img@m.jpg"
							/>
						</div>
					</div>
					<div class="content content02">
						<div class="sec1-swiper mobile-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<img
										src="/static/img/project-detail/hanssem/sec1-slide-img01.jpg"
										alt=""
									/>
								</div>
								<div class="swiper-slide">
									<img
										src="/static/img/project-detail/hanssem/sec1-slide-img02.jpg"
										alt=""
									/>
								</div>
								<div class="swiper-slide">
									<img
										src="/static/img/project-detail/hanssem/sec1-slide-img03.jpg"
										alt=""
									/>
								</div>
							</div>
							<div class="swiper-pagination sec1-pagination"></div>
						</div>
					</div>
				</div>
			</section>
			<section class="section section02 full">
				<div class="inner-section">
					<div class="cont-tit-area max-limit">
						<strong class="project-subtit">Mobile Web</strong>
						<p class="cont-desc">
							웹과 동일한 콘텐츠를 <br class="lb-t" />모바일 디바이스에 맞게
							<br class="lb-t" /><br class="lb-w" />최적화하여 작업 했습니다.
						</p>
					</div>
					<div class="sec2-swiper">
						<div class="swiper-wrapper mobile-swiper">
							<div class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/hanssem/sec2-slide-img01.png"
								/>
							</div>
							<div class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/hanssem/sec2-slide-img02.png"
								/>
							</div>
						</div>
						<div class="swiper-pagination sec2-pagination"></div>
					</div>
					<div class="detail-img">
						<ul>
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/hanssem/sec3-content-img01@m.jpg"
								/>
							</li>
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/hanssem/sec3-content-img02@m.jpg"
								/>
							</li>
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/hanssem/sec3-content-img03@m.jpg"
								/>
							</li>
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/hanssem/sec3-content-img04@m.jpg"
								/>
							</li>
						</ul>
					</div>
				</div>
			</section>
			<section class="section section03">
				<div class="inner-section">
					<div>
						<div class="typograph">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/hanssem/typograph@m.gif"
							/>
						</div>
						<ul class="color">
							<li class="color01">#004f9d</li>
							<li class="color02">#656565</li>
							<li class="color03">#f8b502</li>
							<li class="color04">#070707</li>
							<li class="color05">#ca0909</li>
							<li class="color06">#d32031</li>
						</ul>
					</div>
					<ul class="illustration">
						<li>
							<img
								src="/static/img/project-detail/hanssem/illustration01.gif"
								alt=""
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/hanssem/illustration02.gif"
								alt=""
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/hanssem/illustration03.gif"
								alt=""
							/>
						</li>
						<li>
							<img
								src="/static/img/project-detail/hanssem/illustration04.gif"
								alt=""
							/>
						</li>
					</ul>
				</div>
			</section>
			<!-- Details [e] -->
			<section class="project-client">
				<strong class="a11y-hidden">D.Steady Mall</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider1 = true;
		var isSlider2 = true;
		var sec1Swiper, sec2Swiper;

		var swiper1 = function () {
			if (isSlider1) {
				isSlider1 = false;
				sec1Swiper = new Swiper(".sec1-swiper", {
					slidesPerView: "auto",
					spaceBetween: 30,
					pagination: {
						el: ".sec1-pagination",
						clickable: true,
					},
				});
			}
		};
		var swiper2 = function () {
			if (isSlider2) {
				isSlider2 = false;
				sec2Swiper = new Swiper(".sec2-swiper", {
					spaceBetween: 30,
					pagination: {
						el: ".sec2-pagination",
						clickable: true,
					},
				});
			}
		};

		if (winW < 712) {
			swiper1();
			swiper2();
		} else if (winW >= 712 && winW < 1280) {
			swiper1();
		} else {
			isSlider1 = true;
			isSlider2 = true;
		}

		$window.on("resize", function () {
			winW = $(this).outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					swiper1();
					swiper2();
				}
			} else if (winW >= 712 && winW < 1280) {
				swiper1();
				if (!isSlider2) {
					isSlider2 = true;
					sec2Swiper.destroy();
					$(".sec2-pagination").children().remove();
				}
			} else {
				flag = true;
				if (!isSlider1) {
					isSlider1 = true;
					isSlider2 = true;
					sec1Swiper.destroy();
					sec2Swiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
};
</script>
<!-- css 추가 -->
<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Common */
.section .cont-desc {
	word-break: keep-all;
}
.section.full .con-tit-area {
	max-width: 1280px;
	margin: 0 auto;
}
@media screen and (max-width: 711px) {
	.section.full .max-limit {
		padding: 0 15px;
	}
	.lb-m {
		display: block;
	}
	.lb-t {
		display: none;
	}
	.lb-w {
		display: none;
	}
}
@media screen and (min-width: 712px) {
	.section.full .max-limit {
		padding: 0 40px;
	}
	.lb-m {
		display: none;
	}
	.lb-t {
		display: block;
	}
	.lb-w {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	.section.full {
		max-width: 1920px;
	}
	.section.full .max-limit {
		max-width: 1280px;
		margin: 0 auto;
		padding-left: 20px;
		padding-right: 20px;
	}
	.lb-m {
		display: none;
	}
	.lb-t {
		display: none;
	}
	.lb-w {
		display: block;
	}
}
/* Project Visual, Project CI */
.project-tit em {
	display: block;
}
.project-client {
	background: url(/static/img/project-detail/hanssem/ci.gif) 50%/197px 18px
		no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/hanssem/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/hanssem/bg-overview@t.jpg);
	}
	.project-client {
		background-size: 197px 18px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/hanssem/bg-overview@w.jpg);
	}
	.project-client {
		background-size: 537px 48px;
	}
}

/* Project Overview */
.project-overview {
	background-color: #f8b502;
	color: #fff;
}
.project-overview-diagram {
	margin-top: 25px;
}
.project-overview-diagram:after {
	content: "";
	display: block;
	clear: both;
}
.diagram01 {
	position: relative;
}
.diagram01 li,
.diagram02 li {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	text-align: center;
}
.diagram01 li {
	position: absolute;
	border: 1px solid #fff;
}
.diagram02 li {
	background-color: #fff;
	color: #f8b502;
}
.diagram02 li:before {
	content: "";
	position: absolute;
	border-right: 2px solid #fff;
	border-bottom: 2px solid #fff;
}
@media screen and (max-width: 1279px) {
	.diagram01 li,
	.diagram02 li {
		width: 138px;
		height: 138px;
	}
	.project-overview-txt br {
		display: none;
	}
}
@media screen and (max-width: 711px) {
	.diagram01 {
		height: 252px;
	}
	.diagram01 li {
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.diagram01 li:nth-child(1) {
		margin-left: -64px;
		margin-top: -54px;
	}
	.diagram01 li:nth-child(2) {
		margin-left: 64px;
		margin-top: -54px;
	}
	.diagram01 li:nth-child(3) {
		margin-top: 54px;
	}
	.diagram02 li {
		margin: 31px auto 0 auto;
	}
	.diagram02 li:before {
		top: -32px;
		left: 50%;
		width: 16px;
		height: 16px;
		margin-left: -10px;
		transform: rotate(45deg);
	}
}
@media screen and (min-width: 712px) {
	.project-overview-diagram {
		width: 614px;
		margin: 40px auto 0 auto;
	}
	.project-overview-diagram:after {
		content: "";
		display: block;
		clear: both;
	}
	.diagram01,
	.diagram02 {
		float: left;
	}
	.diagram01 {
		width: 400px;
		height: 138px;
	}
	.diagram01 li:nth-child(2) {
		margin-left: 130px;
	}
	.diagram01 li:nth-child(3) {
		margin-left: 260px;
	}
	.diagram02 {
		margin-left: 75px;
	}
	.diagram02 li:before {
		left: -58px;
		width: 20px;
		height: 20px;
		transform: rotate(-45deg);
	}
}
@media screen and (min-width: 1280px) {
	.project-overview {
		padding: 65px 0;
	}
	.project-overview-diagram {
		width: 1080px;
	}
	.project-overview-diagram:after {
		content: "";
		display: block;
		clear: both;
	}
	.diagram01 {
		float: left;
	}
	.diagram01 li {
		border: 2px solid #fff;
	}
	.diagram01 li,
	.diagram02 li {
		width: 240px;
		height: 240px;
		font-size: 2rem;
	}
	.diagram01 {
		width: 680px;
		height: 240px;
	}
	.diagram01 li:nth-child(2) {
		margin-left: 220px;
	}
	.diagram01 li:nth-child(3) {
		margin-left: 440px;
	}
	.diagram02 {
		float: right;
	}
	.diagram02 li:before {
		left: -108px;
		width: 32px;
		height: 32px;
	}
}

/* section01 : PC Web */
.layer-project-detail > .section01.full {
	padding: 0;
}
.section01 .content01 .detail-img {
	position: relative;
}
.section01 .content01 .detail-img:before {
	content: "";
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
}
.section01 .content01 .detail-img img {
	position: relative;
	z-index: 10;
}
.section01 .content02 {
	position: relative;
}
.section01 .content02 .sec1-swiper {
	margin: 0 auto;
}
@media screen and (max-width: 711px) {
	.section01 .project-subtit {
		margin-bottom: 8px;
	}
	.section01 .content01 {
		padding-top: 9.375vw;
		background: url(/static/img/project-detail/hanssem/sec1-tit-bg@m.jpg)
			no-repeat;
		background-size: 100% auto;
	}
	.section01 .content01 .cont-tit-area {
		margin-bottom: 52.34375vw;
	}
	.section01 .content01 .detail-img {
		margin-top: -15.625vw;
		padding-bottom: 27px;
	}
	.section01 .content01 .detail-img:before {
		height: 57px;
		background: url(/static/img/project-detail/hanssem/sec1-main-bg@m.png)
			center no-repeat;
		background-size: auto 57px;
	}
	.section01 .content01 .detail-img img {
		box-shadow: 0px 18px 17px 0px rgba(0, 0, 0, 0.1);
	}
	.section01 .content02 {
		margin-top: 32px;
	}
	.section01 .content02 .sec1-swiper {
		width: 71.875vw;
	}
	.section01 .content02 .swiper-pagination {
		bottom: -50px;
		visibility: visible;
	}
	.section01 .content02 .swiper-slide {
		box-shadow: 0px 18px 17px 0px rgba(0, 0, 0, 0.1);
	}
}
@media screen and (min-width: 712px) {
	.section01 .detail-img {
		margin-top: 31px;
	}
	.section01 .content01 {
		padding-top: 4.213vw;
		background: url(/static/img/project-detail/hanssem/sec1-tit-bg@t.jpg)
			no-repeat;
		background-size: 100% auto;
	}
	.section01 .content01 .cont-tit-area {
		margin-bottom: 16.8539vw;
	}
	.section01 .content01 .detail-img {
		margin-top: -12.64vw;
		padding-bottom: 83px;
	}
	.section01 .content01 .detail-img:before {
		height: 97px;
		background: url(/static/img/project-detail/hanssem/sec1-main-bg@t.png)
			center no-repeat;
		background-size: auto 13.97vw;
	}
	.section01 .content01 .detail-img img {
		box-shadow: 0px 35px 30px 0px rgba(0, 0, 0, 0.1);
	}
	.section01 .content02 {
		margin-top: 88px;
	}
	.section01 .content02 .sec1-swiper {
		width: 52.668vw;
	}
	.section01 .content02 .swiper-slide {
		box-shadow: 0px 35px 30px 0px rgba(0, 0, 0, 0.1);
	}
	.section01 .content02 .swiper-pagination {
		bottom: -80px;
	}
}
@media screen and (min-width: 1280px) {
	.section01 {
		position: relative;
	}
	.section01:after {
		content: "";
		position: absolute;
		bottom: -871px;
		left: 245px;
		width: 650px;
		height: 1219px;
		background: url(/static/img/project-detail/hanssem/sec2-bg@w.png) no-repeat;
	}
	.section01 .detail-img {
		margin-top: 53px;
		padding-bottom: 80px;
		text-align: center;
	}
	.section01 .content01 {
		position: relative;
		padding-top: 100px;
		background: url(/static/img/project-detail/hanssem/sec1-tit-bg@w.jpg)
			no-repeat;
		background-size: 100% auto;
	}
	.section01 .content01:before {
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 325px;
		background: url(/static/img/project-detail/hanssem/sec1-main-bg@w.png)
			center no-repeat;
		background-size: 100% auto;
	}
	.section01 .content01 .cont-tit-area {
		margin-bottom: 285px;
	}
	.section01 .content01 .detail-img {
		margin-top: -230px;
		padding-bottom: 100px;
	}
	.section01 .content01 .detail-img:before {
		display: none;
	}
	.section01 .content01 .detail-img img {
		box-shadow: 0px 33px 40px 0px rgba(0, 0, 0, 0.1);
	}
	.section01 .content02 {
		margin-top: 88px;
	}
	.section01 .content02 .sec1-swiper {
		width: 100%;
	}
	.section01 .content02 .swiper-pagination {
		visibility: hidden;
	}
	.section01 .content02 .swiper-wrapper {
		display: flex;
		position: relative;
		left: calc(50% - 1098px);
		text-align: center;
	}
	.section01 .content02 .swiper-slide {
		width: 638px;
		margin: 0 47px;
		box-shadow: 0px 35px 30px 0px rgba(0, 0, 0, 0.1);
	}
}
/* section02 : Mobile Web */
.section02 .content01 {
	position: relative;
}
.section02 .sec2-swiper {
	position: relative;
}
.section02 .detail-img ul {
	display: flex;
	justify-content: center;
	align-items: center;
}
.section02 .detail-img li {
	display: block;
}
@media screen and (max-width: 711px) {
	.section02 {
		background: url(/static/img/project-detail/hanssem/sec2-bg@m.png) no-repeat;
		background-size: contain;
	}
	.section02 .inner-section {
		padding-top: 50px;
	}
	.section02 .project-subtit {
		margin-bottom: 8px;
	}
	.section02 .sec2-swiper {
		margin: 27px 0 45px;
		padding-bottom: 10px;
	}
	.section02 .sec2-swiper .swiper-slide {
		text-align: center;
	}
	.section02 .sec2-swiper .swiper-slide img {
		width: 52.1052vw;
	}
	.section02 .detail-img {
		padding-bottom: 48px;
	}
	.section02 .detail-img ul {
		flex-wrap: wrap;
	}
	.section02 .detail-img li {
		width: 41.71875vw;
		margin-bottom: 19px;
		box-shadow: 0px 18px 20px 0px rgba(0, 0, 0, 0.22);
	}
	.section02 .detail-img li:nth-child(odd) {
		margin-right: 22px;
	}
}
@media screen and (min-width: 712px) {
	.section02 {
		background: url(/static/img/project-detail/hanssem/sec2-bg@t.png) no-repeat;
		background-size: contain;
		background-position-y: -37vw;
	}
	.section02 .inner-section {
		position: relative;
		padding-top: 13.778vw;
	}
	.section02 .project-subtit {
		margin-bottom: 12px;
	}
	.section02 .sec2-swiper {
		position: absolute;
		top: 7.64vw;
		right: 40px;
	}
	.section02 .sec2-swiper .swiper-slide {
		width: 23.0337vw;
	}
	.section02 .sec2-swiper .swiper-slide:nth-child(2) {
		margin-top: 4.2134vw;
	}
	.section02 .detail-img {
		padding-top: 35.286vw;
		padding-bottom: 48px;
	}
	.section02 .detail-img ul {
		justify-content: space-between;
		padding: 0 40px;
	}
	.section02 .detail-img li {
		width: 19.662vw;
		margin-right: 23px;
		box-shadow: 0px 18px 20px 0px rgba(0, 0, 0, 0.22);
	}
	.section02 .detail-img li:nth-child(4) {
		margin-right: 0;
	}
}
@media screen and (min-width: 1280px) {
	.section02 {
		background: none;
	}
	.section02 .inner-section {
		position: relative;
		padding-top: 150px;
	}
	.section02 .project-subtit {
		margin-bottom: 25px;
	}
	.section02 .sec2-swiper {
		position: absolute;
		top: 80px;
		left: calc(50% - 93px);
	}
	.section02 .sec2-swiper .swiper-slide {
		width: 328px;
	}
	.section02 .sec2-swiper .swiper-slide:nth-child(2) {
		margin-top: 65px;
	}
	.section02 .detail-img {
		padding: 580px 0 100px;
	}
	.section02 .detail-img ul {
		justify-content: center;
		padding: 0 53px;
	}
	.section02 .detail-img li {
		width: 320px;
		margin-right: 54px;
		box-shadow: 0px 33px 40px 0px rgba(0, 0, 0, 0.22);
	}
	.section02 .detail-img li:nth-child(4) {
		margin-right: 0;
	}
}

/* Typo & Color */
.section03 {
	background-color: #f5f5f5;
}
.color {
	display: flex;
	flex-wrap: wrap;
	font-size: 0;
}
.color li {
	position: relative;
	color: #222;
}
.color li:before,
.color li:after {
	content: "";
	position: absolute;
	border-radius: 50%;
}
.color li:before {
	left: 0;
	background-color: #fff;
}
.color01:after {
	background-color: #004f9d;
}
.color02:after {
	background-color: #656565;
}
.color03:after {
	background-color: #f8b502;
}
.color04:after {
	background-color: #070707;
}
.color05:after {
	background-color: #ca0909;
}
.color06:after {
	background-color: #d32031;
}

@media screen and (max-width: 711px) {
	.typograph {
		width: 257px;
	}
	.color {
		margin-top: 10px;
	}
	.color li {
		width: 50%;
		height: 46px;
		line-height: 46px;
		margin-top: 20px;
		padding-left: 60px;
		font-size: 1.4rem;
	}
	.color li:before {
		width: 46px;
		height: 46px;
	}
	.color li:after {
		top: 13px;
		left: 13px;
		width: 20px;
		height: 20px;
	}
	.illustration:after {
		content: "";
		display: block;
		clear: both;
	}
	.illustration li {
		float: left;
		width: 50%;
		margin-top: 23px;
	}
	.illustration li:nth-child(2n) {
		padding-left: 10px;
	}
	.illustration li:nth-child(2n + 1) {
		padding-right: 10px;
	}
}
@media screen and (min-width: 712px) {
	.section03 .inner-section > div:after {
		content: "";
		display: block;
		clear: both;
	}
	.typograph {
		float: left;
		width: 257px;
		padding-top: 40px;
	}
	.color {
		float: right;
		width: 296px;
	}
	.color li {
		width: 50%;
		height: 46px;
		line-height: 46px;
		margin-top: 20px;
		padding-left: 60px;
		font-size: 1.4rem;
	}
	.color li:before {
		width: 46px;
		height: 46px;
	}
	.color li:after {
		top: 13px;
		left: 13px;
		width: 20px;
		height: 20px;
	}
	.illustration {
		display: flex;
		justify-content: space-between;
		margin-top: 40px;
	}
	.illustration li {
		max-width: 116px;
	}
	.illustration li + li {
		margin-left: 55px;
	}
}
@media screen and (min-width: 1280px) {
	.section03 {
		padding: 60px 0 100px 0;
	}
	.typograph {
		width: 513px;
		padding-top: 87px;
	}
	.color {
		width: 568px;
	}
	.color li {
		height: 92px;
		line-height: 92px;
		margin-top: 40px;
		padding-left: 120px;
		font-size: 1.6rem;
	}
	.color li:before {
		width: 92px;
		height: 92px;
	}
	.color li:after {
		top: 26px;
		left: 26px;
		width: 40px;
		height: 40px;
	}
	.illustration {
		margin-top: 80px;
	}
	.illustration li {
		max-width: 232px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/hanssem-o4o.vue